import { render } from "./ToggleMobileSettings.vue?vue&type=template&id=764fb0cf&scoped=true"
import script from "./ToggleMobileSettings.vue?vue&type=script&lang=ts"
export * from "./ToggleMobileSettings.vue?vue&type=script&lang=ts"

import "./ToggleMobileSettings.vue?vue&type=style&index=0&id=764fb0cf&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-764fb0cf"

export default script